import { render, staticRenderFns } from "./ListViewMortgages.vue?vue&type=template&id=2847cb46"
import script from "./ListViewMortgages.vue?vue&type=script&lang=ts"
export * from "./ListViewMortgages.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports